import React from "react";
import { api_host } from "../common/globals/constants";

export function useGetRegistrosPlusConfig({ objetivoId }) {
    const [data, setData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [isSuccess, setIsSuccess] = React.useState(false);

    React.useEffect(() => {
        if (!objetivoId) {
            return;
        }
        fetchConfig();
    }, [objetivoId]);

    function refetch() {
        fetchConfig();
    }

    async function fetchConfig() {
        setIsLoading(true);
        setIsSuccess(false);
        let token = sessionStorage.getItem("key");
        try {
            const response = await fetch(
                `${api_host}/reporte/general/objetivos/${objetivoId}/pasos_config_obj/getUltimaConfig/?token=${token}&fecha=${new Date().getTime()}`
            );
            if (!response.ok) {
                throw new Error("Error al obtener la configuración");
            }
            const myJson = await response.json();
            setData(myJson);
            setIsSuccess(true);
            setIsError(false);
        } catch (e) {
            console.error(e);
            setIsError(true);
            setIsSuccess(false);
        } finally {
            setIsLoading(false);
        }
    }

    return {
        data,
        isLoading,
        isError,
        isSuccess,
        refetch,
    };
}
